export default __webpack_public_path__ + "static/media/02_MINE_02-min.2ea50f38.jpg";